import React from 'react'
import Modal from 'react-modal'
import classNames from 'classnames'

import { CloseIcon } from 'components/Utils/Icons'
import IconButton from 'components/Utils/IconButton'

import {
  MODAL_FULLSCREEN_STYLE,
  MODAL_FULLSCREEN_CLASS,
  MODAL_DEFAULT_STYLE,
  MODAL_DEFAULT_CLASS,
} from './style'

export function WrapperLayout({
  children,
  modalRef = undefined,
  wide = false,
  auto = false,
  size = undefined,
  center = undefined,
  isOpen = false,
  onRequestClose = undefined,
  closeActiveModal = undefined,
  fullScreenModal = undefined,
  fullScreenModalCloseIcon = undefined,
  fullScreenModalLogo = undefined,
  className = undefined,
  ...otherProps
}) {
  let width = auto ? 'auto' : 665
  if (wide) {
    width = 800
  }
  if (size) {
    width = size
  }
  const {
    top,
    left,
    transform,
    margin,
    ...contentStyle
  } = MODAL_DEFAULT_STYLE.content

  const style = fullScreenModal
    ? MODAL_FULLSCREEN_STYLE
    : {
        content: {
          ...contentStyle,
          width,
          top: center ? '50%' : top,
          left: center ? '50%' : left,
          transform: center ? 'translate(-50%, -50%)' : transform,
          margin: center ? '0' : margin,
        },
        overlay: MODAL_DEFAULT_STYLE.overlay,
      }

  return (
    <React.Fragment>
      <Modal
        style={style}
        isOpen={isOpen}
        ref={modalRef}
        onRequestClose={onRequestClose}
        shouldCloseOnOverlayClick={!fullScreenModal}
        className={classNames(
          fullScreenModal ? MODAL_FULLSCREEN_CLASS : MODAL_DEFAULT_CLASS,
          className
        )}
        {...otherProps}
      >
        {children}
      </Modal>
      {fullScreenModalCloseIcon && (
        <IconButton
          className="position-absolute margin-largest zindex-mega "
          style={{
            top: 0,
            right: 0,
          }}
          onClick={closeActiveModal}
        >
          <CloseIcon className="shade-20 shade-10-on-hover pointer" size={16} />
        </IconButton>
      )}
      {fullScreenModalLogo && (
        <div
          className="position-absolute margin-larger zindex-mega"
          style={{
            top: 0,
            left: 0,
          }}
        >
          <img
            src="https://storage.googleapis.com/slite-cdn/logos/slite/grey.svg"
            height="22"
            alt="slite"
          />
        </div>
      )}
    </React.Fragment>
  )
}
